import { Plus as PlusIcon } from "lucide-react";
import * as React from "react";

import { Popover, RobotoButton } from "@/shared/foundation/primitives";

import { CreateDevice } from "./CreateDevice";

/**
 * "New Device" action for the devices page. Opens the create-device form in a
 * popover anchored to the button; the form closes it on a successful create.
 */
export function CreateDeviceButton() {
  const [open, setOpen] = React.useState(false);

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      // The button sits at the right end of the toolbar, so anchor the popup's
      // right edge to it and let it open leftward, staying on screen.
      align="end"
      aria-label="Create device"
      trigger={
        <RobotoButton variant="primary" icon={<PlusIcon aria-hidden="true" />}>
          New Device
        </RobotoButton>
      }
    >
      <CreateDevice close={() => setOpen(false)} />
    </Popover>
  );
}
